import { store } from '../store';

const useHeaders = () => {
  const jwt = store.getState().auth.jwt;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    url: window.location.href,
  };

  if (jwt) headers.Authorization = `Bearer ${jwt}`;

  return headers;
};

export default useHeaders;
